export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_ACCOUNT_DETAILS = 'SET_ACCOUNT_DETAILS';
export const SET_FETCH_USER_STATUS = 'SET_FETCH_USER_STATUS';
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const SET_STRIPE_CONNECTED_STATUS = 'SET_STRIPE_CONNECTED_STATUS';